<template>
  <v-data-table class="elevation-4 transparent"
                :headers="headers"
                :mobile-breakpoint="null"
                :items="items"
                item-key="index"
                :no-data-text="$dictionary.get('basket-empty')"
                disable-pagination
                hide-default-footer
  >
    <template v-slot:item.quantity="{item}">
      <div class="text-no-wrap">
        <v-btn v-if="actions" icon @click="basketPlus(item)">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        {{ item.quantity }}
        <v-btn v-if="actions" icon :disabled="item.quantity <= 1" @click="basketMinus(item)">
          <v-icon>mdi-minus</v-icon>
        </v-btn>
      </div>
    </template>
    <template v-if="actions" v-slot:item.delete="{item}">
      <v-btn icon @click="basketRemove(item)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
    <template v-slot:item.name="{ item }">
      <div class="text-no-wrap">
        {{ item.item.name }}
      </div>
    </template>
    <template v-slot:item.price="{ item }">
      <div class="text-no-wrap">
        {{ $tools.money(item.item.priceFinal) }}
      </div>
    </template>
    <template v-slot:item.sum="data">
      <div class="text-no-wrap">
        {{ $tools.money(data.item.sum) }}
      </div>
    </template>
    <template v-slot:item.weight="{ item }">
      <div class="text-no-wrap">
        {{ item.item.weight ? $tools.weight(item.item.weight) : null }}
      </div>
    </template>
    <template v-if="items.length > 0" v-slot:body.append>
      <tr>
        <td v-once>
          {{ $dictionary.get('delivery') }}
        </td>
        <td :colspan="keys.length - 2" />
        <td class="text-right text-no-wrap">
          {{ delivery ? $tools.money(delivery) : $dictionary.get('free-of-charge') }}
        </td>
        <td v-if="actions" />
      </tr>
      <tr class="font-weight-bold">
        <td>{{ $dictionary.get('checkout-total') }}</td>
        <td class="text-right">
          {{ totals.quantity }}
          <v-btn v-if="actions" icon disabled />
        </td>
        <td v-if="hasWeight" class="text-right text-no-wrap">
          {{ $tools.weight(totals.weight) }}
        </td>
        <td />
        <td class="text-right text-no-wrap">
          {{ $tools.money(totals.price) }}
        </td>
        <td v-if="actions">
          <v-btn icon @click="basketClear()">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>

export default {
  name: 'ProductsTable',
  props: {
    delivery: { type: Number, default: null, required: false },
    keys: { type: Array, default: null, required: true },
    items: { type: Array, default: null, required: true },
    totals: { type: Object, default: null, required: true },
    actions: { type: Boolean, default: false },
  },
  computed: {
    headers() {
      const out = this.keys.map((value) => ({
        value,
        text: this.$dictionary.get(`checkout-${value}`),
        align: value === 'name' ? 'left' : 'right'
      }));
      if (this.actions) {
        out.push({
          value: 'delete',
          align: 'right'
        });
      }
      return out;
    },
    hasWeight() {
      return this.keys.includes('weight');
    }
  },
  methods: {
    basketPlus(item) {
      this.$emit('plus', item);
    },
    basketClear() {
      this.$emit('clear');
    },

    basketRemove(item) {
      this.$emit('remove', item);
    },
    basketMinus(item) {
      if (item.quantity > 1) {
        this.$emit('minus', item);
      }
    }
  }
};
</script>
